import styled from "@emotion/styled";
import Autocomplete from "@mui/material/Autocomplete";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { BaseInput } from "scmp-app/components/common/base-input";

import CloseIconSvg from "./icon-close.svg";
import MagnifierSvg from "./icon-magnifier-dark.svg";

export const Container = styled.div`
  position: relative;

  & .MuiAutocomplete-listbox {
    max-block-size: 340px;
    padding-block: 12px;
    padding-inline: 0;

    line-height: normal;

    overflow-y: auto;
  }

  && .MuiAutocomplete-option {
    min-block-size: 37px;
    padding-block: 8px;
    padding-inline: 20px;

    font-size: 18px;
  }
`;

export const StyledBaseInput = styled(BaseInput)`
  gap: 8px;
  align-items: center;

  border-block-end: 1px solid #000000;

  margin-block-start: -8px;
  padding-block: 8px;

  ${theme.breakpoints.up("tablet")} {
    gap: 16px;

    margin-block-start: -16px;
    padding-block: 16px;
  }
`;

export const StyledInput = styled.input`
  flex-grow: 1;

  inline-size: 100%;
  min-inline-size: 0;
  /* Match the SEARCH button height so the row keeps a stable height whether or
   * not the button/clear are rendered (prevents layout shift on type/clear). */
  min-block-size: 24px;

  color: #000000;
  font-weight: 500;
  font-size: 16px;
  font-family: ${fontRoboto};

  outline: 0;

  appearance: none;

  &::placeholder {
    color: #727272;
  }

  ${theme.breakpoints.up("tablet")} {
    min-block-size: 44px;

    font-size: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;

    overflow: hidden;
  }
`;

export const LeadingMagnifier = styled(MagnifierSvg)`
  display: none;
  flex-shrink: 0;

  inline-size: 24px;
  block-size: 24px;

  pointer-events: none;

  & path {
    fill: #333333;
  }

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const EndAdornment = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: 8px;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    gap: 12px;
  }
`;

export const ClearButton = styled.button`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  border: 0;

  background: transparent;

  cursor: pointer;
`;

export const ClearFade = styled.div`
  position: absolute;
  inset-block: 0;
  inset-inline-end: 100%;

  inline-size: 24px;

  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);

  pointer-events: none;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 40px;
  }
`;

export const ClearCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 16px;
  block-size: 16px;

  border-radius: 9999px;

  background: #dfdfdf;

  ${theme.breakpoints.up("tablet")} {
    inline-size: 24px;
    block-size: 24px;
  }
`;

export const CloseIcon = styled(CloseIconSvg)`
  inline-size: 8px;
  block-size: 8px;

  & path {
    fill: #888888;
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: 10px;
    block-size: 10px;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;

  block-size: 24px;
  padding-inline: 8px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: 1;
  white-space: nowrap;
  text-transform: uppercase;

  border: 0;
  border-radius: 2px;

  background: #2c4692;

  cursor: pointer;

  ${theme.breakpoints.up("tablet")} {
    block-size: 44px;
    padding-block: 12px;
    padding-inline: 16px;

    font-size: 20px;

    border-radius: 4px;
  }
`;

export const StyledAutocomplete = styled(Autocomplete)`
  && .MuiAutocomplete-inputRoot {
    padding-inline: 0;
  }
`;
